import React, { use, useContext, useEffect, useState } from "react";
import axios from "../axios/axios";
import Context from "../../Context/Context";
import SolicitacaoesCaptacaoAvaliacao from "./SolicitacoesCaptacaoAvaliacao";
import { useLocation, useNavigate } from "react-router-dom";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { IoCloseCircle } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import Modal from "../../utils/Modal";

const mapDepartamentos = {
  1: "Administrativo",
  2: "Jurídico",
  3: "Estratégico",
  4: "Comercial",
  5: "Marketing",
  6: "Recuperacação ExtraJudicial",
};

const mapSetor = {
  1: "Captação",
  2: "Negócios",
  3: "Api",
  4: "Controladoria",
  5: "Editais",
  6: "Encerramentos",
  7: "Publicação",
  8: "Financeiro",
  9: "Departamento_Pessoal",
  10: "Infraestrutura",
  11: "Nenhum",
};

const campos = [
  "dataSolicitacao",
  "dataConclusao",
  "diretorio",
  "vara",
  "foro",
  "juizo",
  "dadosExequente",
  "advogado",
  "tipoBem",
  "estado",
  "prioridade",
  "processo",
  "status",
  "tipoSolicitacao",
  "data_entrega",
  "dadosImovel",
  "link_relatorio",
  "num_matricula",
  "cartorio"
];

const camposMap = {
  dataSolicitacao: "Data de Solicitação",
  dataConclusao: "Data de Conclusão",
  diretorio: "Diretório",
  vara: "Vara",
  foro: "Foro",
  juizo: "Juíz",
  dadosExequente: "Dados do Exequente",
  advogado: "Advogado",
  tipoBem: "Tipo do Bem",
  estado: "Estado",
  prioridade: "Prioridade",
  processo: "Processo",
  status: "Status",
  tipoSolicitacao: "Tipo de Solicitação",
  data_entrega: "Data de Entrega",
  dadosImovel: "Dados do Imóvel",
  link_relatorio: "Link do relatório",
  num_matricula: "Número da Matrícula",
  cartorio: "Cartório",
};

const mapColor = {
  Prejudicado: "bg-red-600 text-white",
  Pendente: "bg-yellow-400 text-black",
  Correção: "bg-cyan-400",
  Realizado: "bg-green-300",
  Enviado: "bg-blue-700 text-white",
  Rejeitado: "bg-red-500 text-white",
  Concluído: "bg-green-700 text-white",
};

function SolicitacaoAndamento() {
  // SolicitacaoAvaliacaoCaptacao
  const { usuario, setSolicitacaoAndamentoId } = useContext(Context);
  const [solicitacoesCaptacaoAvaliacao, setSolicitacoesCaptacaoAvaliacao] =
    useState([]);
  const [minhasSolicitacoes, setMinhasSolicitacoes] = useState([]);
  const [isMine, setIsMine] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [solicitacaoToEdit, setSolicitacaoToEdit] = useState();
  const location = useLocation();
  const nav = useNavigate();
  const [page, setPage] = useState(0);
  const [pageMinhasSolicitacoes, setPageMinhasSolicitacoes] = useState(0);
  const [filters, setFilters] = useState({});
  const [filtersMinhas, setFiltersMinhas] = useState({});
  const [filtrandoTodas, setFiltrandoTodas] = useState(false);
  const [filtrandoMinhas, setFiltrandoMinhas] = useState(false);
  const [resolvendo, setResolvendo] = useState(false);
  const [solicitacaoResolvendoId, setSolicitacaoResolvendoId] = useState(null);
  const [justificando, setJustificando] = useState(false);
  const [resolvendoIndex, setResolvendoIndex] = useState();
  const [justificativa, setJustificativa] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const [solicitacaoStatus, setSolicitacaoStatus] = useState();
  const [motivoPrejudicado, setMotivoPrejudicado] = useState("");
  const [verDadosImovel, setVerDadosImovel] = useState(false)
  const [dadosImovel, setDadosImovel] = useState(null)
  const [vendoDados, setVendoDados] = useState(false)
  const [solicitacaoVizualizar, setSolicitacaoVizualizar] = useState(null)

  const getSolicitacoesCaptacaoAvaliacao = async () => {
    const { data } = await axios.get("/solicitacao/captacao/avaliacao");
    data?.reverse();
    setSolicitacoesCaptacaoAvaliacao(data);
    setMinhasSolicitacoes(data.filter((e) => e?.responsavel_id == usuario.id));
  };

  useEffect(() => {
    if (usuario) {
      if (
        !usuario.role.includes("Captação") &&
        !usuario.role.includes("Avaliação") &&
        !usuario.role.includes("Supervisor")
      )
        nav(-1);
    }
  }, [usuario?.role]);

  useEffect(() => {
    if (solicitacoesCaptacaoAvaliacao?.length > 0) {
      setMinhasSolicitacoes(
        solicitacoesCaptacaoAvaliacao.filter(
          (e) => e?.solicitante_id == usuario.id,
        ),
      );
    }
  }, [solicitacoesCaptacaoAvaliacao]);

  // todas vez que mudar as SOlicitacoesGerais deve fazer esse filter
  useEffect(() => {
    getSolicitacoesCaptacaoAvaliacao();
  }, []);

  const tornarMinha = async (solicitacao) => {
    if (
      !usuario.role.includes("Avaliação") &&
      !usuario.role.includes("Supervisor")
    ) {
      return alert("Não Autorizado");
    }
    const { data } = await axios.put(
      "/solicitacao/captacao/avaliacao/tornarMinha/" + solicitacao.id,
      {},
      {
        headers: { Authorization: usuario.token },
      },
    );
    setMinhasSolicitacoes((prev) => {
      return [data, ...prev];
    });
    console.log(minhasSolicitacoes);
    setSolicitacoesCaptacaoAvaliacao((prev) => {
      return [
        data,
        ...solicitacoesCaptacaoAvaliacao.filter(
          (e) => +e.id != +solicitacao.id,
        ),
      ];
    });
  };

  // useEffect(() => {
  //   console.log(minhasSolicitacoes)
  // }, [minhasSolicitacoes])

  // const editarSolicitacao = async (solicitacao) => {
  //   const { data } = await axios.put('/solicitacao/captacao/avaliacao/'+solicitacao.id, formData)
  // }

  const resolve = (str) => {
    if (!str) {
      return JSON.stringify("Sem dados")
    }
    return str
  }

  const handleClickTarget = () => {
    setIsEditing(false);
    setSolicitacaoToEdit(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleChangeMinhas = (e) => {
    const { name, value } = e.target;
    setFiltersMinhas({ ...filtersMinhas, [name]: value });
  };

  const formatData = (data) => {
    return data?.toString()?.toLowerCase() || "";
  };

  return (
    <div
      onClick={() => {
        setFiltrandoTodas(false);
        setFiltrandoMinhas(false);
      }}
      className="flex flex-col justify-center w-[100%] items-center gap-10"
    >
      <div className="flex gap-5 rouded px-5 py-2 rounded-lg">
        <button
          onClick={() => setIsMine(false)}
          className={`${!isMine && "bg-black text-white"} p-2 hover:!bg-gray-700 hover:!text-white`}
        >
          Todas Solicitações
        </button>
        <button
          onClick={() => setIsMine(true)}
          className={`${isMine && "bg-black text-white  "} hover:!bg-gray-700 hover:!text-white p-2`}
        >
          Minhas Solicitações
        </button>
      </div>

      <Modal active={vendoDados} setActive={setVendoDados}>
        <h2 className="text-black text-left text-lg font-extralight italic ">Dados do Solicitante</h2>
        <p><span className="font-bold">Nome do Solicitante:</span> {solicitacaoVizualizar?.nomeSolicitante}</p>
        <p><span className="font-bold">Documento do Solicitante:</span> {solicitacaoVizualizar?.documentoSolicitante}</p>
        <p><span className="font-bold">Endereço do Solicitante:</span> {solicitacaoVizualizar?.enderecoSolicitante}</p>
      </Modal>


      {showStatus &&
        !["Concluído", "Enviado", "Pendente", "Correção"].includes(
          solicitacaoStatus.status,
        ) && (
          <div
            onClick={() => setShowStatus(false)}
            className="modal-overlay overflow-y-auto"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="edit-captacao-modal !overflow-y-auto relative"
            >
              <button
                onClick={() => setShowStatus(false)}
                className="!bg-transparent absolute right-0 top-1 mt-2 mr-[-30px]"
              >
                <IoCloseCircle
                  className="text-black hover:text-gray-600"
                  fontSize={22}
                />
              </button>
              {solicitacaoStatus?.motivo_rejeicao && (
                <section>
                  <p className="tracking-wider font-semibold">
                    Motivo Rejeição:
                  </p>
                  <p className="">{solicitacaoStatus.motivo_rejeicao}</p>
                </section>
              )}

              {solicitacaoStatus?.justificativa_avaliacao && (
                <section>
                  <p className="tracking-wider font-semibold">
                    Motivo Justificativa:
                  </p>
                  <p className="">
                    {solicitacaoStatus.justificativa_avaliacao}
                  </p>
                </section>
              )}

              {/* 
            {solicitacaoStatus?.status == 'Prejudicado' && (
              <div>
                <p className='tracking-wider font-semibold'>Justificativa:</p>
                <label>
                  <input disabled={true} value={justificativa} onChange={(e) => setJustificativa(e.target.value)} type="text" />
                </label>

              </div>
            )} */}
            </div>
          </div>
        )}

      {/* <div onClick={(e) =>{
        e.stopPropagation()
        if(isMine) {
          setFiltrandoMinhas(true)
        } else {
          setFiltrandoTodas(true)
        }
      }} className='flex justify-center items-center gap-5 cursor-pointer'>
      <HiOutlineAdjustmentsHorizontal fontSize={23}  />
      <p>Filtrar Elementos</p>
    </div> */}

      <div className="flex gap-5 justify-center items-center">
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (isMine) {
              setFiltrandoMinhas(true);
            } else {
              setFiltrandoTodas(true);
            }
          }}
          className="flex justify-center items-center gap-2 cursor-pointer mb-10"
        >
          <HiOutlineAdjustmentsHorizontal fontSize={23} />
          <p>Filtrar Elementos</p>
        </div>

        <div
          onClick={(e) => {
            e.stopPropagation();
            if (isMine) {
              setFiltersMinhas({});
            } else {
              setFilters({});
            }
          }}
          className="flex justify-center items-center gap-2 cursor-pointer mb-10"
        >
          <RiDeleteBin5Fill fontSize={23} />
          <p>Excluir Filtros</p>
        </div>
      </div>

      {filtrandoTodas && (
        <div className="modal-overlay overflow-y-auto">
          <div
            onClick={(e) => e.stopPropagation()}
            className="edit-captacao-modal !overflow-y-auto"
          >
            <form>
              {campos.map((cp) => (
                <label className="flex flex-col gap-2" key={cp} l>
                  <p>{camposMap[cp]}</p>
                  <input
                    placeholder={camposMap[cp]}
                    name={cp}
                    onChange={handleChange}
                    value={filters[cp]}
                    type={cp.includes("data") ? "date" : "text"}
                  />
                </label>
              ))}
            </form>
          </div>
        </div>
      )}

      {filtrandoMinhas && (
        <div className="modal-overlay overflow-y-auto">
          <div
            onClick={(e) => e.stopPropagation()}
            className="edit-captacao-modal !overflow-y-auto"
          >
            <form>
              {campos.map((cp) => (
                <label
                  className="flex flex-col gap-2"
                  key={cp + JSON.stringify(isMine)}
                  l
                >
                  <p>{camposMap[cp]}</p>
                  <input
                    placeholder={camposMap[cp]}
                    name={cp}
                    onChange={handleChangeMinhas}
                    value={filtersMinhas[cp]}
                    type={cp.includes("data") ? "date" : "text"}
                  />
                </label>
              ))}
            </form>
          </div>
        </div>
      )}

      {verDadosImovel && (
        <div onClick={() => setVerDadosImovel(false)} className="modal-overlay !w-auto">
          {/* com StopPropagation ele não captura o onClick no pai, somente no filho, pois ele para a propagação de pai no filho */}
          <div onClick={(e) => e.stopPropagation()} className="edit-captacao-modal !w-auto !overflow-x-auto !overflow-y-auto relative ">
            <section className="!bg-transparent !text-black !m-0 !p-0 absolute !right-0 top-0 !mt-2 !mr-2 cursor-pointer"> <IoMdCloseCircleOutline onClick={() => setVerDadosImovel(false)} fontSize={22} className="" />  </section>
            <h2 className="font-bold text-black text-start">Dados do imóvel:</h2>
            <pre className="whitespace-pre-wrap font-sans">
              {dadosImovel}
            </pre>
          </div>
        </div>
      )}

      {isMine && (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg w-full  scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-700 transition-all ease-in-out">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="!bg-red-500 text-xs text-gray-700 uppercase dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-6 py-3 bg-black">Nº do Processo</th>
                <th className="px-6 py-3 bg-black">Data da Solicitação</th>
                <th className="px-6 py-3 bg-black">Data Prazo</th>
                <th className="px-6 py-3 bg-black">Diretório</th>
                <th className="px-6 py-3 bg-black">Vara</th>
                <th className="px-6 py-3 bg-black">Foro</th>
                <th className="px-6 py-3 bg-black">Juíz</th>
                <th className="px-6 py-3 bg-black">Dados Exequente</th>
                <th className="px-6 py-3 bg-black">Número Da Matrícula</th>
                <th className="px-6 py-3 bg-black">Cartório</th>
                <th className="px-6 py-3 bg-black">Link do Relatório</th>
                <th className="px-6 py-3 bg-black">Advogado</th>
                <th className="px-6 py-3 bg-black">Dados do Imóvel</th>
                <th className="px-6 py-3 bg-black">Tipo do bem</th>
                <th className="px-6 py-3 bg-black">Estado</th>
                <th className="px-6 py-3 bg-black">Prioridade</th>
                <th className="px-6 py-3 bg-black">Status</th>
                <th className="px-6 py-3 bg-black">Tipo da Solicitacao</th>
                <th className="px-6 py-3 bg-black">Departamento</th>
                <th className="px-6 py-3 bg-black">Setor</th>
                <th className="px-6 py-3 bg-black">Data da Entrega</th>
                {/* <th className="px-6 py-3 bg-black">Motivo Rejeição</th>
              <th className="px-6 py-3 bg-black">Justificativa</th> */}
                <th className="px-6 py-3 bg-black">Ação</th>
              </tr>
            </thead>
            <tbody>
              {minhasSolicitacoes
                .filter((sol) => {
                  // console.log('filtrando:', Object.keys(filtrandoMinhas))
                  return Object.keys(filtersMinhas).every((key) =>
                    formatData(sol[key]).includes(
                      formatData(filtersMinhas[key]),
                    ),
                  );
                })
                ?.slice(
                  pageMinhasSolicitacoes * 10,
                  pageMinhasSolicitacoes * 10 + 10,
                )
                .map((solicitacao, index) => (
                  <tr
                    key={index}
                    className={`bg-white border-b text-black dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ${solicitacao.status == "Rejeitado" && "text-red-600"}`}
                  >
                    <td className="px-6 py-4">{solicitacao.processo}</td>
                    <td className="px-6 py-4">
                      {solicitacao.dataSolicitacao
                        ?.split("T")[0]
                        .split("-")
                        .reverse()
                        .join("/")}
                    </td>
                    <td className="px-6 py-4">
                      {solicitacao.dataConclusao
                        ?.split("T")[0]
                        .split("-")
                        .reverse()
                        .join("/")}
                    </td>
                    <td className="px-6 py-4">{solicitacao.diretorio}</td>
                    <td className="px-6 py-4">{solicitacao.vara}</td>
                    <td className="px-6 py-4">{solicitacao.foro}</td>
                    <td className="px-6 py-4">{solicitacao.juizo}</td>
                    <td className="px-6 py-4 hover:bg-gray-400">
                      <button disabled={solicitacao?.nomeSolicitante ? false: true} className="bg-gray-700 px-2 whitespace-nowrap text-white py-1" onClick={() => {
                        setVendoDados(true)
                        setSolicitacaoVizualizar(solicitacao)
                      }}>Ver dados</button>
                    </td>
                    <td className="px-6 py-4">{solicitacao.num_matricula}</td>
                    <td className="px-6 py-4">{solicitacao.cartorio}</td>
                    <td className="px-6 py-4">{solicitacao.link_relatorio}</td>
                    <td className="px-6 py-4">{solicitacao.advogado}</td>
                    <td className="px-6 py-4">
                      <pre className="whitespace-pre-wrap font-sans">
                        {JSON.parse(resolve(solicitacao.dadosDoImovel))?.slice(0, 25)}
                        <br />
                        {JSON.parse(resolve(solicitacao.dadosDoImovel))?.length > 25 && (
                          <button onClick={() => {
                            setVerDadosImovel(true)
                            setDadosImovel(JSON.parse(resolve(solicitacao.dadosDoImovel)))
                          }} className="text-[12px] text-gray-400 hover:bg-transparent hover:scale-100 hover:text-gray-600 cursor-pointer">
                            veja mais...
                          </button>
                        )}
                      </pre>
                    </td>
                    <td className="px-6 py-4">{solicitacao.tipoBem}</td>
                    <td className="px-6 py-4">{solicitacao.estado}</td>
                    <td className="px-6 py-4">{solicitacao.prioridade}</td>
                    <td className={`px-6 py-4`}>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setShowStatus(true);
                          setSolicitacaoStatus(solicitacao);
                          setSolicitacaoResolvendoId(+solicitacao.id);
                          setResolvendoIndex(index);
                          setJustificativa(
                            solicitacao.justificativa_avaliacao || "",
                          );
                        }}
                      >
                        <p
                          className={`${mapColor[solicitacao.status]} px-8 py-2 rounded-lg text-center`}
                        >
                          {solicitacao.status}
                        </p>
                      </div>
                    </td>
                    <td className="px-6 py-4">{solicitacao.tipoSolicitacao}</td>
                    <td className="px-6 py-4">
                      {mapDepartamentos[solicitacao.departamento_id]}
                    </td>
                    <td className="px-6 py-4">
                      {mapSetor[solicitacao.setor_id]}
                    </td>
                    <td className="px-6 py-4">
                      {!solicitacao.data_entrega
                        ? "Não Entregue"
                        : solicitacao.data_entrega
                          ?.split("T")[0]
                          .split("-")
                          .reverse()
                          .join("/")}
                    </td>
                    {/* <td className="px-6 py-3">{solicitacao.motivo_rejeicao}</td>
                <td className="px-6 py-3">{solicitacao.justificativa_avaliacao}</td> */}

                    <td className="px-6 py-4">
                      <button
                        className="btn-status bg-black text-white hover:!bg-gray-700 w-[100%] px-2 py-2 font-semibold"
                        onClick={() => {
                          setIsEditing(true);
                          setSolicitacaoToEdit(solicitacao);
                        }}
                      >
                        Editar
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {!isMine && (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg w-full   scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-700 transition-all ease-in-out">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr className="!bg-black">
                <th className="px-6 py-3 bg-black">Nº do Processo</th>
                <th className="px-6 py-3 bg-black">Data de Solicitação</th>
                <th className="px-6 py-3 bg-black">Data da Conclusão</th>
                <th className="px-6 py-3 bg-black">Diretório</th>
                <th className="px-6 py-3 bg-black">Vara</th>
                <th className="px-6 py-3 bg-black">Foro</th>
                <th className="px-6 py-3 bg-black">Juíz</th>
                <th className="px-6 py-3 bg-black">Dados Exequente</th>
                <th className="px-6 py-3 bg-black">Número Da Matrícula</th>
                <th className="px-6 py-3 bg-black">Cartório</th>
                <th className="px-6 py-3 bg-black">Link do Relatório</th>
                <th className="px-6 py-3 bg-black">Advogado</th>
                <th className="px-6 py-3 bg-black">Dados do Imóvel</th>
                <th className="px-6 py-3 bg-black">Tipo do bem</th>
                <th className="px-6 py-3 bg-black">Estado</th>
                <th className="px-6 py-3 bg-black">Prioridade</th>
                <th className="px-6 py-3 bg-black">Status</th>
                <th className="px-6 py-3 bg-black">Responsável</th>
                <th className="px-6 py-3 bg-black">Tipo da Solicitacao</th>
                <th className="px-6 py-3 bg-black">Departamento</th>
                {/* <th className="px-6 py-3 bg-black">Motivo Rejeição</th>
              <th className="px-6 py-3 bg-black">Justificativa</th> */}
                <th className="px-6 py-3 bg-black">Setor</th>
                {/* <th className="px-6 py-3 bg-black">Ação</th> */}
              </tr>
            </thead>
            <tbody>
              {solicitacoesCaptacaoAvaliacao
                .filter((sol) => {
                  // console.log('filtrando:', Object.keys(filtrandoMinhas))
                  return Object.keys(filters).every((key) =>
                    formatData(sol[key]).includes(formatData(filters[key])),
                  );
                })
                ?.slice(page * 10, page * 10 + 10)
                ?.map((solicitacao, index) => (
                  <tr
                    key={index}
                    className="border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                  >
                    <td className="px-6 py-4">{solicitacao.processo}</td>
                    <td className="px-6 py-4">
                      {solicitacao.dataSolicitacao
                        ?.split("T")[0]
                        .split("-")
                        .reverse()
                        .join("/")}
                    </td>
                    <td className="px-6 py-4">
                      {solicitacao.dataConclusao
                        ?.split("T")[0]
                        .split("-")
                        .reverse()
                        .join("/")}
                    </td>
                    <td className="px-6 py-4">{solicitacao.diretorio}</td>
                    <td className="px-6 py-4">{solicitacao.vara}</td>
                    <td className="px-6 py-4">{solicitacao.foro}</td>
                    <td className="px-6 py-4">{solicitacao.juizo}</td>
                    <td className="px-6 py-4 hover:bg-gray-400">
                      <button disabled={solicitacao?.nomeSolicitante ? false: true} className="bg-gray-700 px-2 whitespace-nowrap text-white py-1" onClick={() => {
                        setVendoDados(true)
                        setSolicitacaoVizualizar(solicitacao)
                      }}>Ver dados</button>
                    </td>
                    <td className="px-6 py-4">{solicitacao.num_matricula}</td>
                    <td className="px-6 py-4">{solicitacao.cartorio}</td>
                    <td className="px-6 py-4">{solicitacao.link_relatorio}</td>
                    <td className="px-6 py-4">{solicitacao.advogado}</td>
                    <td className="px-6 py-4">
                      <pre className="whitespace-pre-wrap font-sans">
                        {JSON.parse(resolve(solicitacao.dadosDoImovel))?.slice(0, 25)}
                        <br />
                        {JSON.parse(resolve(solicitacao.dadosDoImovel))?.length > 25 && (
                          <button onClick={() => {
                            setVerDadosImovel(true)
                            setDadosImovel(JSON.parse(resolve(solicitacao.dadosDoImovel)))
                          }} className="text-[12px] text-gray-400 hover:bg-transparent hover:scale-100 hover:text-gray-600 cursor-pointer">
                            veja mais...
                          </button>
                        )}
                      </pre>
                    </td>
                    <td className="px-6 py-4">{solicitacao.tipoBem}</td>
                    <td className="px-6 py-4">{solicitacao.estado}</td>
                    <td className="px-6 py-4">{solicitacao.prioridade}</td>
                    <td className={`px-6 py-4`}>
                      <div
                        className=""
                        onClick={() => {
                          // setShowStatus(true)
                          // setSolicitacaoStatus(solicitacao)
                          // setSolicitacaoResolvendoId(+solicitacao.id)
                          // setResolvendoIndex(index)
                          // setJustificativa(solicitacao.justificativa_avaliacao || '')
                        }}
                      >
                        <p
                          className={`${mapColor[solicitacao.status]} px-8 py-2 rounded-lg text-center`}
                        >
                          {solicitacao.status}
                        </p>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      {solicitacao.responsavel?.nome || "Sem Responsável"}
                    </td>
                    <td className="px-6 py-4">{solicitacao.tipoSolicitacao}</td>
                    <td className="px-6 py-4">
                      {mapDepartamentos[solicitacao.departamento_id]}
                    </td>
                    {/* <td className="px-6 py-3">{solicitacao.motivo_rejeicao}</td>
                <td className="px-6 py-3">{solicitacao.justificativa_avaliacao}</td> */}
                    <td className="px-6 py-4">
                      {mapSetor[solicitacao.setor_id]}
                    </td>
                    {/* <td className="px-6 py-4">
                  <button className="btn-status bg-black text-white px-2 py-2 hover:!bg-gray-700 font-semibold" onClick={() => {
                    setIsEditing(true)
                    setSolicitacaoToEdit(solicitacao)
                  }}>Editar</button>
                </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {isEditing && (
        <div onClick={handleClickTarget} className="modal-overlay">
          <div
            onClick={(e) => e.stopPropagation()}
            className="edit-captacao-modal !overflow-y-scroll"
          >
            <SolicitacaoesCaptacaoAvaliacao
              solicitacaoToEdit={solicitacaoToEdit}
              setIsEditing={setIsEditing}
              setSolicitacaoToEdit={setSolicitacaoToEdit}
              isEditing={isEditing}
              solicitacoesCaptacaoAvaliacao={solicitacoesCaptacaoAvaliacao}
              setSolicitacoesCaptacaoAvaliacao={
                setSolicitacoesCaptacaoAvaliacao
              }
            />
          </div>
        </div>
      )}
      {isMine ? (
        <div className="flex justify-center mt-16 gap-5 items-center">
          <button
            className="px-5 py-1 disabled:!bg-gray-300 text-white bg-black"
            onClick={() =>
              setPageMinhasSolicitacoes(pageMinhasSolicitacoes - 1)
            }
            disabled={pageMinhasSolicitacoes == 0}
          >
            Anterior
          </button>
          <p>Página {pageMinhasSolicitacoes + 1}</p>
          <button
            disabled={
              minhasSolicitacoes.slice(
                pageMinhasSolicitacoes * 10,
                pageMinhasSolicitacoes * 10 + 10,
              ).length < 10
            }
            className="px-5 py-1 !bg-black text-white"
            onClick={() =>
              setPageMinhasSolicitacoes(pageMinhasSolicitacoes + 1)
            }
          >
            Próxima
          </button>
        </div>
      ) : (
        <div className="flex justify-center mt-16 gap-5 items-center">
          <button
            className="px-5 py-1 disabled:!bg-gray-300 text-white bg-black"
            onClick={() => setPage(page - 1)}
            disabled={page == 0}
          >
            Anterior
          </button>
          <p>Página {page + 1}</p>
          <button
            disabled={
              solicitacoesCaptacaoAvaliacao.slice(page * 10, page * 10 + 10)
                .length < 10
            }
            className="px-5 py-1 !bg-black text-white"
            onClick={() => setPage(page + 1)}
          >
            Próxima
          </button>
        </div>
      )}
    </div>
  );
}

export default SolicitacaoAndamento;
